import React from "react";
import "./Values.css";

function Values() {
  const valuesList = [
    {
      title: "Mission",
      desc: "To provide comprehensive and compassionate healthcare to women and children, focusing on maternity care, child care and general medical services. We ensure a safe and nurturing environment for expectant mothers, with personalised care and support throughout the pregnancy journey."
    },
    {
      title: "Vision",
      desc: "To be the leading maternity hospital in the region, recognised for exceptional healthcare and commitment to patient satisfaction. We continually enhance our medical expertise, infrastructure and technology, and aim to create an environment where every patient feels valued, heard and respected."
    },
    {
      title: "Philosophy",
      desc: "Every woman deserves access to safe, reliable and affordable maternity care. Pregnancy and childbirth are significant milestones, and we work to make the journey as comfortable and memorable as possible, considering the physical, emotional and psychological wellbeing of each patient."
    }
  ];

  return (
    <section className="band" id="values">
      <div className="wrap">
        <p className="eyebrow">What we stand for</p>
        <h2 className="h-sec">Mission, vision and philosophy.</h2>
        <div className="values">
          {valuesList.map((val, idx) => (
            <div className="value" key={idx}>
              <h3>{val.title}</h3>
              <p>{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Values;
